import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';
import ArrowIcon from '@/srp/PromoBanner/ArrowIcon';

export const BackGroundImage = createComponent('img', {
  className: 'absolute h-full left-0 object-cover top-0 w-full z-0'
});

export const BannerWrapper = createComponent('div', {
  className:
    'bg-white border border-grey-2 flex mb-16 min-h-[106px] overflow-hidden pl-24 pr-48 py-12 relative rounded-lg m:h-[160px] m:mb-32 m:pl-[190px] m:pr-40 m:rounded-xl'
});

export const CloseWrapper = createComponent('div', {
  className:
    'absolute flex h-24 items-center justify-center right-16 top-16 w-24'
});

export const ContentWrapper = createComponent('div', {
  className: 'flex items-center relative w-full z-[1] m:justify-between'
});

export const PriceDropArrow = createComponent<
  ElementWithProps<{ isRestricted: boolean }>
>(ArrowIcon, props => ({
  className: cx(
    'absolute h-20 m:-translate-y-1/2 m:h-auto m:right-[52px] m:top-1/2 m:w-auto',
    props.isRestricted
      ? '-rotate-45 w-20 top-20 right-[34px]'
      : 'w-24 top-[22px] right-32'
  )
}));

export const TextWrapper = createComponent('div', {
  className:
    'flex flex-col gap-8 text-blue-6 m:gap-4 m:max-w-[481px] m:min-w-[275px]'
});
